import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

import { MEDIA_QUERY_SMALL_SCREEN } from 'client/constants/mediaQueries';

import SrFormikField, { SR_FIELD_THEME_ADOBE } from 'client/components/SrFormikField';
import SrCard from 'client/components/SrCard/SrCard';
import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';

const SrPartnerMarketListingFormStepSimple = ({
  formikBag,
  formFields,
}) => {
  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  return (
    <SrCard>
      {formFields.map((formField, index) => (
        <div key={formField.id}>
          <SrBox>
            <SrFormikField
              formField={formField}
              formikBag={formikBag}
              theme={SR_FIELD_THEME_ADOBE}
              margin={index === 0 ? '0px' : null}
            />
          </SrBox>
          {formField.type !== 'hidden' && formField.actionLink && (
            <SrBox
              marginTop='15px'
              marginBottom='24px'
              onClick={formField.actionLink.onClick}
            >
              <SrText
                font='greycliff'
                color='blue300'
                weight='800'
                align={isSmallScreen ? 'center' : null}
                size='16'
                lineHeight='25px'
                cursor='pointer'
                display='block'
              >
                {formField.actionLink.text}
              </SrText>
            </SrBox>
          )}
          {formField.type !== 'hidden' && formField.additionalComponent}
        </div>
      ))}
    </SrCard>
  );
};

SrPartnerMarketListingFormStepSimple.propTypes = {
  formikBag: PropTypes.object.isRequired,
  formFields: PropTypes.array.isRequired,
};

SrPartnerMarketListingFormStepSimple.displayName = 'SrPartnerMarketListingFormStepSimple';

export default SrPartnerMarketListingFormStepSimple;
